// extracted by mini-css-extract-plugin
export var callCard = "_s8-0";
export var callMessageButton = "_s8-1";
export var helpIcon = "_s8-3";
export var helpIconContainer = "_s8-4";
export var verticalDivider = "_s8-2";